<div class="link" (click)="backToBulk()">< Back</div>
<h1>Bulk Domain Task Group Details</h1>
<p>Detailed info about all the tasks in the current task group.</p>

<div class="info_row">
    <span class="label">Group ID:</span>
    <span class="data">{{this.groupId}}</span>
</div>
<div class="info_row">
    <span class="label">Type:</span>
    <span class="data">{{this.groupDetails()?.type}}</span>
</div>
@if (this.groupDetails()?.other) {
    <div class="info_row">
        <span class="label">Other:</span>
        <span class="data">{{this.groupDetails()?.other}}</span>
    </div>
}
@if (this.groupDetails()) {
    <!-- Which backend enqueued this group: the production and staging backends
         share a database, and a staging-initiated group still performs real
         registry operations. -->
    <div class="info_row">
        <span class="label">Origin:</span>
        <span class="data origin"
              [class.staging]="this.groupDetails()?.origin === 'staging'"
        >{{this.groupDetails()?.origin}}</span>
    </div>
}
@if (this.groupDetails()?.user_email) {
    <div class="info_row">
        <span class="label">User:</span>
        <span class="data">{{this.groupDetails()?.user_email}}</span>
    </div>
}

@if (this.groupDetails()) {
    <div class="paginator_row">
        <span id="table_title">Group Tasks</span>
        <mat-paginator #paginator
                       [length]="totalTaskCount()"
                       [showFirstLastButtons]="true"
                       [pageIndex]="0"
                       [pageSize]="DEFAULT_PAGE_SIZE"
                       [pageSizeOptions]="PAGE_SIZE_OPTIONS"
                       (page)="onPageChange($event)"></mat-paginator>
    </div>
    <div id="table_scroller">
        <table mat-table [dataSource]="dataSource()">

            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef>ID</th>
                <td mat-cell *matCellDef="let task" [innerHTML]="task.id"></td>
            </ng-container>

            <ng-container matColumnDef="domain">
                <th mat-header-cell *matHeaderCellDef>Domain</th>
                <td mat-cell *matCellDef="let task" [innerHTML]="task.domain"></td>
            </ng-container>

            <ng-container matColumnDef="completed">
                <th mat-header-cell *matHeaderCellDef>Completed</th>
                <td mat-cell *matCellDef="let task" [innerHTML]="formatTimestamp(task.completed)"></td>
            </ng-container>

            <ng-container matColumnDef="last_failed">
                <th mat-header-cell *matHeaderCellDef>Last Failed</th>
                <td mat-cell *matCellDef="let task" [innerHTML]="formatTimestamp(task.last_failed)"></td>
            </ng-container>

            <ng-container matColumnDef="failures">
                <th mat-header-cell *matHeaderCellDef>Failure</th>
                <td mat-cell *matCellDef="let task" [innerHTML]="task.failures"></td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="COLUMNS_TO_DISPLAY"></tr>
            <tr mat-row *matRowDef="let _; columns: COLUMNS_TO_DISPLAY"></tr>

        </table>
    </div>
}
